import { SelectedFilter } from '../models'

export const reformatFilterProperties = (selectedFilters: SelectedFilter[]): SelectedFilter[] => {
  const mergedProperties: SelectedFilter = { properties: '' }
  for (const obj of selectedFilters) {
    for (const key in obj) {
      if (key.startsWith('properties')) {
        mergedProperties.properties = mergedProperties.properties ? `${mergedProperties.properties}|${obj[key]}` : obj[key]
        continue
      }

      mergedProperties[key] = obj[key]
    }
  }

  return [mergedProperties]
}

/**
 * Retrieves the values of a specific filter from the selected filters and converts them into an array.
 */
export const revertFilterChange = (key: string, selectedFilters: SelectedFilter[]): string[] => {
  const filter = selectedFilters.find(item => item[key])

  if (filter) {
    return filter[key].split('|').filter(Boolean)
  }

  return []
}
